import type { KeyboardShortcutKeys } from '../types/keyboard-shortcut-keys.js';
import { isMacPlatform } from './user-agent-utils.js';

const MOD_MODIFIER = 'mod';

function selectPlatformCombination(
  keys: KeyboardShortcutKeys,
  isMac: boolean,
): string {
  if (typeof keys === 'string') {
    return keys;
  }

  if (isMac && keys.macos) {
    return keys.macos;
  }

  return keys.default;
}

/**
 * Resolves a key combination for the current platform: selects the `macos`
 * override on macOS, and replaces the non-standard `mod` modifier with `Meta` on
 * macOS or `Control` on every other platform.
 *
 * The result is a single combination in the `aria-keyshortcuts` format.
 * @internal
 */
export function resolveKeyboardShortcutKeys(
  keys: KeyboardShortcutKeys,
): string {
  const isMac = isMacPlatform();
  const platformModifier = isMac ? 'Meta' : 'Control';

  return selectPlatformCombination(keys, isMac)
    .split('+')
    .map((key) => (key.toLowerCase() === MOD_MODIFIER ? platformModifier : key))
    .join('+');
}
